// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BUbHisRAQ3jDOgmoSyLB {
  width: 100%;
  height: 100%;
  max-height: 100%;
  background-color: transparent;
  border: none;
}

.fpUeN3HTjHZXGnZJSVRs {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--step-2);
  color: var(--white-color);
  background: none;
  background-color: transparent;
  border: none;
  border-radius: 0;
  opacity: 0.6;
  mix-blend-mode: hard-light;
  cursor: pointer;
  transition: var(--global-nav-transition);
  z-index: 100;
}

.HVok2E63yhBPAcSOWcUE {
  display: flex;
  justify-content: end;
  width: 85%;
}

.j5dJnyo9E9FhxfXLFye5 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.MW5LwcmX5Fy4mGANos00 {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  width: 80%;
  height: 50%;
  background-color: var(--white-color);
  padding: var(--space-s-l);
  border-radius: var(--space-xl);
}

.BUbHisRAQ3jDOgmoSyLB {
  animation: Nz5Rh5M5Z_P5SoiHskO7 0.7s ease-out forwards; /* Animation for fade-in */
  transition:
    visibility 0s 0.7s,
    opacity 0.7s linear; /* Transitions for fade-out */
  opacity: 1;
  visibility: visible;
}

.BUbHisRAQ3jDOgmoSyLB[hidden] {
  visibility: hidden;
  opacity: 0;
  animation: WTVQtYIhEItYwa2VyFHQ 0.5s ease-out forwards; /* Apply fade-out when modal is hidden */
}

.BUbHisRAQ3jDOgmoSyLB[open]::backdrop {
  background-color: rgba(var(--primary-color-rgb), 0.9);
  backdrop-filter: blur(16px);
  transition:
    opacity 0.7s ease-out,
    visibility 0s 0.7s;
}

.BUbHisRAQ3jDOgmoSyLB::backdrop {
  visibility: visible;
  opacity: 1;
}

.BUbHisRAQ3jDOgmoSyLB[hidden]::backdrop {
  visibility: hidden;
  opacity: 0;
}

.V7qrYSXoHGRTIn08xtVV {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
}

.V7qrYSXoHGRTIn08xtVV i {
  font-size: 72px;
  color: darkgrey;
}

@keyframes Nz5Rh5M5Z_P5SoiHskO7 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes WTVQtYIhEItYwa2VyFHQ {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/widgets/dialogs/MapBoxDialog.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,sDAAwC,EAAE,0BAA0B;EACpE;;uBAEqB,EAAE,6BAA6B;EACpD,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sDAAyC,EAAE,wCAAwC;AACrF;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B;;sBAEoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".modal {\n  width: 100%;\n  height: 100%;\n  max-height: 100%;\n  background-color: transparent;\n  border: none;\n}\n\n.modalCloseBtn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: var(--step-2);\n  color: var(--white-color);\n  background: none;\n  background-color: transparent;\n  border: none;\n  border-radius: 0;\n  opacity: 0.6;\n  mix-blend-mode: hard-light;\n  cursor: pointer;\n  transition: var(--global-nav-transition);\n  z-index: 100;\n}\n\n.modalCloseBtnWrapper {\n  display: flex;\n  justify-content: end;\n  width: 85%;\n}\n\n.modalContentWrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n.modalContent {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: stretch;\n  width: 80%;\n  height: 50%;\n  background-color: var(--white-color);\n  padding: var(--space-s-l);\n  border-radius: var(--space-xl);\n}\n\n.modal {\n  animation: fadeIn 0.7s ease-out forwards; /* Animation for fade-in */\n  transition:\n    visibility 0s 0.7s,\n    opacity 0.7s linear; /* Transitions for fade-out */\n  opacity: 1;\n  visibility: visible;\n}\n\n.modal[hidden] {\n  visibility: hidden;\n  opacity: 0;\n  animation: fadeOut 0.5s ease-out forwards; /* Apply fade-out when modal is hidden */\n}\n\n.modal[open]::backdrop {\n  background-color: rgba(var(--primary-color-rgb), 0.9);\n  backdrop-filter: blur(16px);\n  transition:\n    opacity 0.7s ease-out,\n    visibility 0s 0.7s;\n}\n\n.modal::backdrop {\n  visibility: visible;\n  opacity: 1;\n}\n\n.modal[hidden]::backdrop {\n  visibility: hidden;\n  opacity: 0;\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  text-align: center;\n}\n\n.container i {\n  font-size: 72px;\n  color: darkgrey;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `BUbHisRAQ3jDOgmoSyLB`,
	"modalCloseBtn": `fpUeN3HTjHZXGnZJSVRs`,
	"modalCloseBtnWrapper": `HVok2E63yhBPAcSOWcUE`,
	"modalContentWrapper": `j5dJnyo9E9FhxfXLFye5`,
	"modalContent": `MW5LwcmX5Fy4mGANos00`,
	"fadeIn": `Nz5Rh5M5Z_P5SoiHskO7`,
	"fadeOut": `WTVQtYIhEItYwa2VyFHQ`,
	"container": `V7qrYSXoHGRTIn08xtVV`
};
export default ___CSS_LOADER_EXPORT___;
